import { Form, Formik } from "formik";
import type React from "react";
import { Dialog, DialogBody, DialogTitle } from "../Theme/dialog";
import DefaultDialogActionButtons from "./DefaultDialogActionButtons.tsx";

interface Props {
  buttonLabel: string;
  closeLabel?: string;
  title: string;
  body: string | React.ReactElement;
  className?: string;
  show: boolean;
  disabled?: boolean;
  handleClose: () => void;
  handleAction: () => void;
  // Optional Formik props
  initialValues?: any;
  validationSchema?: any;
  onSubmit?: (values: any, formikHelpers: any) => void | Promise<void>;
}

const ConfirmModal = (props: Props): React.ReactElement => {
  // If Formik props provided, wrap with Formik
  if (props.initialValues && props.onSubmit) {
    return (
      <Dialog
        open={props.show}
        className={props.className}
        onClose={props.handleClose}
      >
        <Formik
          initialValues={props.initialValues}
          validationSchema={props.validationSchema}
          onSubmit={props.onSubmit}
          enableReinitialize={true}
        >
          {({ resetForm }) => (
            <Form>
              <DialogTitle>{props.title}</DialogTitle>
              <DialogBody>{props.body}</DialogBody>
              <DefaultDialogActionButtons
                createButton={{
                  disabled: props.disabled,
                  labelText: props.buttonLabel,
                  type: "submit",
                }}
                cancelButton={{
                  onClick: () => {
                    resetForm();
                    props.handleClose();
                  },
                  labelText: props.closeLabel,
                  type: "reset",
                }}
              />
            </Form>
          )}
        </Formik>
      </Dialog>
    );
  }

  // Default non-Formik mode
  return (
    <>
      <Dialog
        open={props.show}
        className={props.className}
        onClose={props.handleClose}
      >
        <DialogTitle>{props.title}</DialogTitle>
        <DialogBody>{props.body}</DialogBody>
        <DefaultDialogActionButtons
          createButton={{
            disabled: props.disabled,
            onClick: props.handleAction,
            labelText: props.buttonLabel,
            type: "submit",
          }}
          cancelButton={{
            onClick: props.handleClose,
            labelText: props.closeLabel,
            type: "reset",
          }}
        />
      </Dialog>
    </>
  );
};

export default ConfirmModal;
